import { t } from "@/i18n";

const PageHeader = ({ title, subtitle, right, eyebrow }) => (
  <div className="mb-6 flex flex-col gap-4 sm:mb-8 sm:flex-row sm:items-end sm:justify-between">
    <div className="v-fade-up min-w-0 flex-1">
      <div className="v-eyebrow mb-1.5">{eyebrow || t.brand}</div>
      <h1 className="break-words text-2xl font-semibold tracking-tight text-[#f4f1ec] sm:text-3xl md:text-4xl">{title}</h1>
      {subtitle && <p className="mt-1.5 max-w-2xl text-xs sm:text-sm leading-relaxed text-[#a3a3a3]">{subtitle}</p>}
    </div>
    {right && <div className="flex w-full flex-wrap items-center gap-2 sm:w-auto">{right}</div>}
  </div>
);

export const Page = ({ children, className = "", testId }) => (
  <div data-testid={testId} className={`mx-auto w-full max-w-[1400px] px-4 py-6 sm:px-6 sm:py-8 md:px-10 md:py-10 ${className}`}>{children}</div>
);

export default PageHeader;
